(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["b2b-como-trabajamos"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(!root||root.__mmcr)return;
    root.__mmcr=true;
    var track=root.querySelector('.mm-ct__track'),prev=root.querySelector('[data-prev]'),next=root.querySelector('[data-next]');
    function step(){var c=track.children[0];return c?c.getBoundingClientRect().width+16:300;}
    function sync(){var s0=track.scrollLeft<=2,e0=track.scrollLeft+track.clientWidth>=track.scrollWidth-2;prev.disabled=s0;next.disabled=e0;track.classList.toggle('has-left',!s0);track.classList.toggle('is-end',e0);}
    function font(){
      if(root.classList.contains('mm-ct--font'))return;
      var h=root.querySelector('.mm-ct__card h3');if(!h)return;
      var cs=getComputedStyle(h);
      root.querySelectorAll('.mm-ct__n').forEach(function(n){n.style.fontFamily=cs.fontFamily;});
    }
    prev.addEventListener('click',function(){track.scrollBy({left:-step(),behavior:'smooth'});});
    next.addEventListener('click',function(){track.scrollBy({left:step(),behavior:'smooth'});});
    track.addEventListener('scroll',sync,{passive:true});
    window.addEventListener('resize',function(){sync();font();});
    font();sync();
  }
  function all(){document.querySelectorAll('[data-mm-ct]').forEach(init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',all);else all();
  document.addEventListener('shopify:section:load',function(e){var r=e.target&&e.target.querySelector?e.target.querySelector('[data-mm-ct]'):null;init(r);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["b2b-por-que-elegir"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(!root||root.__mmcr)return;
    root.__mmcr=true;
    var track=root.querySelector('.mm-pq__track'),prev=root.querySelector('[data-prev]'),next=root.querySelector('[data-next]');
    function step(){var c=track.children[0];return c?c.getBoundingClientRect().width+16:300;}
    function sync(){var s0=track.scrollLeft<=2,e0=track.scrollLeft+track.clientWidth>=track.scrollWidth-2;prev.disabled=s0;next.disabled=e0;track.classList.toggle('has-left',!s0);track.classList.toggle('is-end',e0);}
    function font(){
      if(root.classList.contains('mm-pq--font'))return;
      var h=root.querySelector('.mm-pq__card h3');if(!h)return;
      var cs=getComputedStyle(h);
      root.querySelectorAll('.mm-pq__n').forEach(function(n){n.style.fontFamily=cs.fontFamily;});
    }
    prev.addEventListener('click',function(){track.scrollBy({left:-step(),behavior:'smooth'});});
    next.addEventListener('click',function(){track.scrollBy({left:step(),behavior:'smooth'});});
    track.addEventListener('scroll',sync,{passive:true});
    window.addEventListener('resize',function(){sync();font();});
    font();sync();
  }
  function all(){document.querySelectorAll('[data-mm-pq]').forEach(init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',all);else all();
  document.addEventListener('shopify:section:load',function(e){var r=e.target&&e.target.querySelector?e.target.querySelector('[data-mm-pq]'):null;init(r);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["siete-reinos_b2b-formulario"] && !Shopify.designMode) return;
  try {
    
(function(){
  function clean(v){return v.replace(/[^0-9kK]/g,'').toUpperCase();}
  function dv(b){var s=0,m=2;for(var i=b.length-1;i>=0;i--){s+=parseInt(b.charAt(i),10)*m;m=m===7?2:m+1;}var r=11-(s%11);return r===11?'0':(r===10?'K':String(r));}
  function fmt(v){var c=clean(v);if(c.length<2)return c;return c.slice(0,-1).replace(/\B(?=(\d\d\d)+(?!\d))/g,'.')+'-'+c.slice(-1);}
  function valid(v){var c=clean(v),b=c.slice(0,-1);return c.length>=8&&c.length<=9&&/^\d+$/.test(b)&&dv(b)===c.slice(-1);}
  document.addEventListener('input',function(e){
    var t=e.target;
    if(t&&t.matches&&t.matches('[data-mm-rut]')){t.value=fmt(t.value);t.setCustomValidity('');}
  });
  document.addEventListener('submit',function(e){
    var f=e.target,r=f&&f.querySelector?f.querySelector('[data-mm-rut]'):null;
    if(r&&!valid(r.value)){r.setCustomValidity('Ingresa un RUT válido, por ejemplo 12.345.678-5');r.reportValidity();e.preventDefault();}
  },true);
})();

  } catch(e) { console.error(e); }
})();
})();
